export default __webpack_public_path__ + "static/media/olusola.b40daecd.jpg";